const messages = {
    en: {
        message: {
            guestLogin: 'Or Login with User ID',
            inputUserId: 'Input Your 9 or 17 digit UserID',
            login: 'Login',
            loginWith: 'Login with',
            orLoginWith: 'Login With',
            userIDErrorTip: 'Error! Please enter the correct user ID.',
            userIDLengthError: '',
            logout: 'LOG OUT',
            confirmLogout: 'Are you sure to log out?',
            yes: 'yes',
            cancel: 'cancel',
            extra: 'EXTRA',
            loading: 'loading',
            moreCoins: 'MORE COINS',
            free: 'FREE',
            freeWheel: 'FREE WHEEL',
            blackWheel: 'BLACK WHEEL',
            okay: 'COLLECT',
            goDrBingo:'GO DR BINGO',
            success: 'SUCCESS!',
            credited: 'YOU HAVE BEEN CREDITED! PLEASE CLICK "COLLECT" TO CLAIM IMMEDIATELY OR GO DR BINGO TO CHECK YOUR BALANCE!',
            paymentTitle: 'CHOOSE PAYMENT METHOD',
            pix: 'PIX',
            otherWays: 'CREDIT CARD, BOLETO <br/>AND OTHERS',
            err_1002: 'Login failed. USERID does not exist',
            err_0001: 'Login failed. Please try again later',
            err_1003: 'Account blocked for purchasing. For more information, please contact our support at support@drbingo.com.',
            tutorialStep1: 'Click "settings" button in the upper right corner',
            tutorialStep2: 'Check your ID here and click "COPY" button to copy it',
            tutorialClose: 'Okay,I see',
            userIDTip: 'This is your User ID. Please, check it in Dr Bingo',
            buyFor: 'BUY FOR',
            bonusModalTitle: "we're sorry",
            bonusNotAvailable: "Bonus already claimed.",
            bonusExpired: "Bonus expired.",
            bonusNotFound: "Bonus ID not found.",
            bonusContinueButton: "Continue"
        }
    },
    es: {
        message: {
            guestLogin: 'O utilice el ID de Usuario para iniciar sesión',
            inputUserId: 'Ingrese su ID de usuario de 9 o 17 dígitos',
            login: 'Iniciar',
            loginWith: 'Inicia con',
            orLoginWith: 'Inicia con',
            userIDErrorTip: '¡Identificación invalida! Por favor ingrese la identificación correcta',
            userIDLengthError: '',
            logout: 'SALIR',
            confirmLogout: '¿Seguro que quieres salir?',
            yes: 'Sí',
            cancel: 'Cancelar',
            extra: 'EXTRA',
            loading: 'cargando',
            moreCoins: 'MÁS MONEDAS',
            free: 'GRATIS',
            freeWheel: 'RULETA GRATIS',
            blackWheel: 'RULETA BLACK',
            okay: 'RECOGER',
            goDrBingo:'ACCEDE A DR.BINGO',
            success: '¡ÉXITO!',
            credited: '¡USTED HA SIDO CRÉDITO! PARA CONSULTAR TU SALDO HAZ CLICK EN “COBRAR” O ACCEDE DIRECTAMENTE A DR BINGO!',
            paymentTitle: 'ELIGE EL MÉTODO DE PAGO',
            pix: 'PIX',
            otherWays: 'TARJETA DE CRÉDITO, <br/>BOLETO Y OTROS',
            err_1002: 'Falló el inicio de sesión. Esta ID de usuario no existe',
            err_0001: 'Falló el inicio de sesión. Por favor, inténtelo de nuevo más tarde',
            err_1003: 'Cuenta bloqueada para realizar compras. Para más información, por favor, ponte en contacto con nuestro soporte en support@drbingo.com.',
            tutorialStep1: 'Haga clic en el botón "configuración" en la esquina superior derecha',
            tutorialStep2: 'Comprueba aquí tu ID y haz clic en el botón "COPIAR"',
            tutorialClose: 'Bueno',
            userIDTip: 'Esta es su ID de usuario. Por favor, revisa la información dentro de Dr.Bingo',
            buyFor: 'COMPRE',
            bonusModalTitle: "Lo sentimos",
            bonusNotAvailable: "Bonus ya reclamado.",
            bonusExpired: "Bonus vencido.",
            bonusNotFound: "ID de Bonus no encontrado.",
            bonusContinueButton: "Continuar"

        }
    },
    pt: {
        message: {
            guestLogin: 'Ou use ID de Usuário para entrar',
            inputUserId: 'Insira o seu ID de usuário de 9 ou 17 dígitos',
            login: 'Entrar',
            loginWith: 'Entrar com',
            orLoginWith: 'Entrar com',
            userIDErrorTip: 'ID Inválido! Por favor, digite o ID correto',
            userIDLengthError: '',
            logout: 'SAIR',
            confirmLogout: 'Você tem certeza que deseja sair?',
            yes: 'Sim',
            cancel: 'Cancelar',
            extra: 'EXTRA',
            loading: 'carregando',
            moreCoins: 'MAIS MOEDAS',
            free: 'GRÁTIS',
            freeWheel: 'ROLETA GRÁTIS',
            blackWheel: 'ROLETA BLACK',
            okay: 'COLETAR',
            goDrBingo:'ACESSE O DR.BINGO',
            success: 'PARABÉNS',
            credited: 'VOCÊ FOI CREDITADO! PARA VERIFICAR O SEU SALDO CLIQUE EM "COLETAR" OU ACESSE DIRETAMENTE O DR BINGO!',
            paymentTitle: 'ESCOLHA O MÉTODO DE PAGAMENTO',
            pix: 'PIX',
            otherWays: 'CARTÃO, BOLETO <br/>E OUTROS',
            err_1002: 'Falha no login. Este ID de usuário não existe',
            err_0001: 'Falha no login. Por favor, tente novamente mais tarde',
            err_1003: 'Conta bloqueada para realização de compras. Para mais informações, por favor, entre em contato com nosso suporte pelo endereço support@drbingo.com.',
            tutorialStep1: 'Clique no botão de "configurações" no canto superior direito',
            tutorialStep2: 'Cheque seu ID aqui e clique no botão "COPIAR"',
            tutorialClose: 'Ok,eu entendo',
            userIDTip: 'Esse é o seu ID de Usuário. Por favor, verifique dentro do Dr.Bingo',
            buyFor: 'COMPRE',
            bonusModalTitle: "Sentimos muito",
            bonusNotAvailable: "Bônus já Recolhido.",
            bonusExpired: "Bônus Expirado.",
            bonusNotFound: "Bônus não Encontrado.",
            bonusContinueButton: "Continuar"
        }
    }
}

export default messages



// WEBPACK FOOTER //
// ./src/i18n.js